import Swiper from 'swiper';
import Checkout from './Checkout';
import SocialConnect from './SocialConnect';

class App {
  constructor() {
    // this.discoverButton();
    this.footer();

    if (window.document.querySelector('.page--shop-home-index')) {
      this.homepage();
    }

    this.errorPageAnimation();

    new Checkout();
    SocialConnect.init();

    this.backToTop();
    this.tooltips();
    this.faq();
  }

  footer() {
    document
      .querySelectorAll('.site-footer-links__links-link')
      .forEach(elem => {
        elem.addEventListener('click', e => {
          e.preventDefault();
          elem.classList.toggle('site-footer-links__links-link--active');
        });
      });
  }

  homepage() {
    const breakpoint = window.matchMedia('(min-width: 50em)');

    let blocSliderSwiper;

    const breakpointChecker = () => {
      if (breakpoint.matches) {
        if (blocSliderSwiper !== undefined) {
          blocSliderSwiper.destroy(true, false);
        }

        return null;
      } else {
        return enableBlocSliderSwiper();
      }
    };

    const enableBlocSliderSwiper = () => {
      const teaserSliderClass = 'teaser-slider';

      if (document.querySelector(`.${teaserSliderClass}`) !== null) {
        blocSliderSwiper = new Swiper(`.${teaserSliderClass}`, {
          slideClass: `${teaserSliderClass}__slide`,
          wrapperClass: `${teaserSliderClass}__wrapper`,
          slidesPerView: 1,
          pagination: {
            el: `.${teaserSliderClass}__pagination`,
            clickable: true,
            bulletClass: `${teaserSliderClass}__pagination-bullet`,
            bulletActiveClass: `${teaserSliderClass}__pagination-bullet--active`,
          },
        });
      }
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  }

  errorPageAnimation() {
    document.querySelectorAll('.page-error__number').forEach(number => {
      number.addEventListener('click', () => {
        number.classList.toggle('page-error__number--active');
      });
    });
  }

  discoverButton() {
    const $discoverButton = document.querySelector('.discover-button');

    if ($discoverButton) {
      $discoverButton.addEventListener('click', function (e) {
        e.preventDefault();

        const id = this.href.split('#')[1];

        document
          .getElementById(id)
          .scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  backToTop() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      const observer = new IntersectionObserver(entries => {
        const value = entries[0].boundingClientRect.y < 0;

        document
          .querySelector('body')
          .classList.toggle('back-to-top-visible', value);

        document
          .querySelector('.back-to-top')
          .classList.toggle('back-to-top--hidden', !value);
      });

      const element = document.querySelector('.back-to-top__anchor');
      if (element) {
        observer.observe(element);
      }
    }
  }

  tooltips() {
    const button = document.querySelector('.tooltips__button');
    const box = document.querySelector('.tooltips__box');
    const backdrop = document.querySelector('.tooltips__backdrop');
    const close = document.querySelector('.tooltips__close');

    const toggleClass = () => {
      box.classList.toggle('tooltips__box--active');
      backdrop.classList.toggle('tooltips__backdrop--active');
    };

    if (button && box && backdrop && close) {
      button.addEventListener('click', () => {
        toggleClass();
      });
      close.addEventListener('click', () => {
        toggleClass();
      });
      backdrop.addEventListener('click', () => {
        toggleClass();
      });
    }
  }

  faq() {
    const buttonsSelector = '.page-faq__links-item';
    const buttons = document.querySelectorAll(buttonsSelector);
    const categories = document.querySelectorAll('.page-faq__category');

    buttons.forEach(button =>
      button.addEventListener('click', () => {
        const activeClass = button.dataset.activeClass;
        const activeButton = document.querySelector(
          `${buttonsSelector}.${activeClass}`
        );

        // remove active class from active button, if any
        if (activeButton) {
          activeButton.classList.remove(activeClass);
        }
        // add active class to clicked button
        button.classList.add(activeClass);

        categories.forEach(category => {
          // remove hidden class from clicked button's category, hide all others
          if (category.dataset.category === button.dataset.category) {
            category.classList.remove(category.dataset.hiddenClass);
          } else {
            category.classList.add(category.dataset.hiddenClass);
          }
        });
      })
    );
  }
}

export default App;
